// src/styles/tokens.js
// Design tokens inline (colori, spacing, section label) condivisi da tutta l'app.
// Mirror in JS delle CSS variables di index.css: qui stanno i valori che servono
// negli inline style, là quelli che servono ai selettori CSS. Se cambi uno,
// cambia l'altro.
//
// Stava in pages/Dashboard.styles.js, ma lo importavano già 4 componenti e
// 5 pagine che con la Dashboard non c'entrano.

export const C = {
  // Accent colors
  accent:  '#FF3962',   // Aura red del logo: riempimenti e icone SENZA testo sopra (3:1)

  // Lo stesso rosso quando il riempimento porta testo bianco: #FF3962 con il
  // bianco sopra fa 3.24:1, sotto la soglia di 4.5. Mirror di --orange.
  // Regola: `background: C.accent` + `color: '#fff'` è sempre un bug, usa questo.
  accentFill: '#EC0031',
  run:     '#16A34A',   // running / cardio green
  flame:   '#EA580C',   // streak / fc orange
  danger:  '#EF4444',   // error / red
  purple:  '#7C5CE0',

  // Secondary — scala accent, mirror inline dei --color-accent-* di index.css
  accent2:     '#007AFF',              // blu pieno: icone, bordi, stati attivi (3:1)
  accent2Fill: '#0071ED',              // blu pieno che porta TESTO BIANCO: #007AFF si ferma a 4.02
  accent2Ink:  '#003C82',              // testo/icone su celeste o su fondo panna
  accent2Tint: '#B3D7FF',              // celeste delicato: superfici soft
  accent2Soft: 'rgba(0,122,255,0.10)', // velo per hover e sfondi appena accennati

  // Scala ink — mirror di index.css. I colori qui sopra sono per i RIEMPIMENTI
  // (3:1 basta); quando lo stesso colore fa da TESTO serve 4.5:1 e si usa questa.
  // 21/08/2026: accentInk/runInk/dangerInk/purpleInk ricalcolati contro il
  // chip tinto più chiaro di ciascuna famiglia (es. rgba(...,0.08-0.12) sopra
  // panna), non contro panna nudo — erano tarati sul bianco puro e cadevano
  // sotto 4.5:1 proprio dove vengono usati (chip colorati). Vedi index.css.
  accentInk: '#CA002A',
  runInk:    '#117A37',
  flameInk:  '#C3490A',
  // Un gradino sotto flameInk, stesso motivo delle righe sopra. Non ha
  // gemello in index.css: nasce inline.
  flameInkDeep: '#A93E08',
  dangerInk: '#CE2121',
  purpleInk: '#643DDA',

  // Deprecati: erano due blu diversi, ora entrambi la scala accent.
  race:    '#007AFF',
  info:    '#007AFF',

  // Text (tinte inline — mirrored dei CSS vars --text*).
  //
  // Erano 5 livelli da 0.62 a 0.34: tutti sotto WCAG AA su fondo panna
  // (0.34 arrivava a 2.07:1, illeggibile). Ora i livelli sono DUE:
  //   text  → titoli e contenuto
  //   text2 → tutto il resto del testo, 0.63 è il minimo per 4.5:1
  // I nomi vecchi restano come alias per non toccare 60+ call-site, ma
  // puntano tutti allo stesso valore: non c'è più una gerarchia di grigi.
  // Per il decoro NON informativo (separatori, sfondi) c'è textFaintDecor.
  text:       '#242325',
  text2:      'rgba(36,35,37,0.63)',
  text3:      'rgba(36,35,37,0.63)',
  textMuted:  'rgba(36,35,37,0.63)',
  textFaint:  'rgba(36,35,37,0.63)',
  textGhost:  'rgba(36,35,37,0.63)',

  // Solo elementi decorativi che non veicolano informazione.
  textFaintDecor: 'rgba(36,35,37,0.49)',

  // Surfaces
  surface1: 'rgba(36,35,37,0.03)',
  surface2: 'rgba(36,35,37,0.05)',
  border1:  'rgba(36,35,37,0.07)',
  border2:  'rgba(36,35,37,0.14)',
}

export const PAD = {
  section:  '1.25rem 1rem 0',
  sectionSm: '1rem 1rem 0',
}

// Etichetta sezione piccola in maiuscolo (titolo di gruppo).
export const sectionLabel = {
  fontSize: 10,
  fontWeight: 800,
  color: C.textFaint,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  marginBottom: 10,
}
